import storageService from "@/services/storage.service";
import utilService from "@/services/util.service";
import { ref } from "vue";
import { usePosts } from "../views/private/timeline/composables/posts.composables";
import router from "@/router/router";
import httpService from "@/services/http.service";
import { RouteEnum } from "@/router/routeNames";
import { isKeycloakEnabled } from "@/services/keycloak.service";
// import AwsAuthService from "@/services/aws.auth.service";
const showSearchBar = ref(false);

export default (props: any) => {
  const isThemePopupShown = ref(false);
  const user = ref();
  const { clearPosts } = usePosts();
  const isProfileBoxShown = ref(false);
  const isSubmenuShown = ref(false);

  const initialData = () => {
    user.value = storageService.getUser();
  };

  const logout = async () => {
    if (isKeycloakEnabled()) {
      clearPosts();
      storageService.logout();
      return;
    }

    let response = await httpService.logoutUser();
    // let response = await AwsAuthService.handleSignOut();

    if (response.isSuccess) {
      clearPosts();
      storageService.logout();
    }
  };

  const getImageUrl = (url: string) =>
    utilService.getImageUrl(url, "/sidemenuicon");
  const toggleSidebar = () => {
    isSubmenuShown.value = false;
    props.toggleSidebar();
  };

  const toggleProfileBox = (val?: boolean) => {
    if (val == false) {
      setTimeout(() => {
        isProfileBoxShown.value = val;
      }, 300);
    } else {
      isProfileBoxShown.value = !isProfileBoxShown.value;
    }
  };

  const toggleSubMenu = () => {
    isSubmenuShown.value = !isSubmenuShown.value;
    props.toggleSidebar(true);
  };

  const goToSettings = () => {
    router.push({ name: "settings" });
  };

  const goToProfile = () => {
    let info: any = storageService.getUser();
    router.push({
      name: RouteEnum.profile,
      params: { username: info.userName },
    });
  };

  const showThemeModal = (val?: boolean) => {
    if (val == false) {
      setTimeout(() => {
        isThemePopupShown.value = val;
      }, 300);
    } else {
      isThemePopupShown.value = !isThemePopupShown.value;
    }
  };

  return {
    showSearchBar,
    isProfileBoxShown,
    isSubmenuShown,
    user,
    toggleProfileBox,
    getImageUrl,
    toggleSidebar,
    logout,
    toggleSubMenu,
    goToSettings,
    initialData,
    goToProfile,
    isThemePopupShown,
    showThemeModal,
  };
};
